import React from 'react';
import { Box, Typography, useTheme, useMediaQuery } from '@mui/material';
import MyImage from '../../images/NEU.png';

const AboutSection = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery('(min-width: 600px) and (max-width: 960px)');

  return (
    <Box sx={{ 
      backgroundColor: 'white', 
      color: 'black', 
      padding: isMobile ? 2 : 8
    }}>
      <Box sx={{ 
        display: 'flex', 
        flexDirection: isMobile ? 'column' : 'row', 
        justifyContent: 'space-between', 
        flexWrap: 'wrap',
        gap: isMobile ? 2 : 0,
        alignItems: 'center'
      }}>
        <Box sx={{ 
          flexBasis: isMobile ? '100%' : isTablet ? '100%' : '35%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          maxHeight: isMobile ? 'auto' : '100%',
          marginTop: isMobile ? '0px': '70px'
        }}>
          <img src={MyImage} alt="NEU background" style={{ width: '100%', height: 'auto', borderRadius: '15px', maxHeight: '100%' }} />
        </Box>
        <Box sx={{ 
          flexBasis: isMobile || isTablet ? '100%' : '60%', 
          textAlign: isMobile || isTablet ? 'center' : 'inherit',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: isMobile || isTablet ? 'center' : 'flex-start',
          paddingTop: isMobile ? '20px' : '0'
        }}>
          <Typography component="h1" sx={{ 
            fontSize: isMobile ? '40px' : '60px', 
            fontWeight: '600',
            color: '#101010',
            marginBottom: isMobile ? '20px' : '10px'
          }}>
            <span style={{ color: '#f9004d' }}>ABOUT</span> ME
          </Typography>
              <Typography paragraph sx={{ 
                          fontSize: isMobile ? '16px' : '20px', 
                          marginBottom: '15px'
                        }}>
                          Hi, I'm Anand Somnath Pandey, a software engineer based in Boston with a strong interest in 
                          Gen AI, agents, and full-stack development.<br/><br/>

                          I recently completed my Master's in Information Systems at Northeastern University in December 2025. 
                          Before that, I spent two years at Wipro Ltd. in Mumbai as a Software Engineer, where I worked on 
                          Python and C/C++ services, DevOps automation, AWS infrastructure, and CI/CD pipelines.<br/><br/>

                          I'm now working as a Software Engineer at Guardian's Embrace, a non-profit, where I ship full-stack 
                          features and contribute to a Gen AI donor assistant. On the side, I build my own projects like 
                          JobHunter AI and PortfolioBot to learn agentic AI patterns hands-on.<br/><br/>

                          My technical toolkit spans Gen AI tools (Claude, Groq, LangChain, RAG, agents), backend (Python, 
                          Node.js, FastAPI, PostgreSQL), cloud (AWS, Docker, Kubernetes), and frontend (React, TypeScript). 
                          I learn by building, I find a hard problem and ship something real.<br/>
                        </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default AboutSection;
